import { useEffect } from 'react'

import { useAtom } from 'jotai'

import { useAppConfig } from '@twisto/base/app-config'

import { useLiveChatWidgetWithoutMainButton } from './live-chat-widget-without-main-button.hook'
import { toggleLivechat } from './toggle-live-chat-atom'
import type { LivechatMainButton } from './types'

type Props = {
  email?: string
  hideChatWidgetMainButton?: boolean
}

export const LiveChatWidget = ({
  email,
  hideChatWidgetMainButton = false,
}: Props) => {
  const { DAKTELA_GUI_SERVER, support } = useAppConfig()
  const { daktelaGuiToken } = support
  const [isLivechatOpen, setLivechatState] = useAtom(toggleLivechat)
  const { hideWidgetMainButton } = useLiveChatWidgetWithoutMainButton(
    hideChatWidgetMainButton
  )

  useEffect(() => {
    if (window.daktelaGui) {
      return
    }

    const daktelaGuiConfig = {
      server: DAKTELA_GUI_SERVER,
      accessToken: daktelaGuiToken,
      settings: {
        inputs: {
          email: { defaultValue: email },
        },
      },
      fnAfterInit: (display: boolean) => {
        if (hideChatWidgetMainButton) {
          hideWidgetMainButton()
        }

        if (display && isLivechatOpen) {
          const mainButton: LivechatMainButton = document.querySelector(
            '[data-component-name="mainButton"]'
          )
          const hideButton: LivechatMainButton = document.querySelector(
            '#daktela-web-header-hide'
          )

          if (mainButton) {
            mainButton.click()
          }

          if (hideButton) {
            hideButton.addEventListener('click', () => {
              if (mainButton) {
                mainButton.style.display = 'none'
              }
            })
          }
        }
      },
    }

    const daktelaScriptEl = document.createElement('script')
    daktelaScriptEl.src = `${daktelaGuiConfig.server}external/web/web.js`
    daktelaScriptEl.type = 'text/javascript'
    daktelaScriptEl.async = true

    daktelaScriptEl.onload = function () {
      if (window.daktelaGui) {
        // eslint-disable-next-line new-cap
        const daktelaWeb = new window.daktelaGui()
        daktelaWeb.init(daktelaGuiConfig)
      }
    }

    document.head.appendChild(daktelaScriptEl)
  }, [
    email,
    DAKTELA_GUI_SERVER,
    daktelaGuiToken,
    isLivechatOpen,
    setLivechatState,
    hideChatWidgetMainButton,
    hideWidgetMainButton,
  ])

  return null
}
